import axios from "axios";
import { API } from "../constants/actionTypes";
import { apiEnd, apiStart } from "../actions/apiActions";
import history from "../history";
import { notification } from "antd";
import { resolveApiRequest } from "../config/apiBase";
//axios default config
// axios.defaults.baseURL = "https://api.myjson.com/bins/";
axios.defaults.headers.common["Content-Type"] = "application/json";
// axios.defaults.headers.common["Authorization"] = `Bearer ${"fakeAccessToken"}`;

const isFunction = (value) =>
  value &&
  (Object.prototype.toString.call(value) === "[object Function]" ||
    "function" === typeof value ||
    value instanceof Function);

//actual middleware implementation
const api = ({ dispatch, getState }) => (next) => (action) => {
  next(action);
  if (action.type !== API) return;
  const {
    url,
    method,
    data,
    onSuccess,
    onFailure,
    label,
    headers,
    onSuccessWithoutDispatch,
    onFailureWithoutDispatch,
  } = action.payload;

  const dataOrParams = ["GET", "DELETE"].includes(method) ? "params" : "data";

  // blow the horn - api requested has started!
  if (label) {
    dispatch(apiStart(label));
  }
  const { baseURL, url: resolvedUrl } = resolveApiRequest(url);

  //make actual request
  axios
    .request({
      baseURL,
      url: resolvedUrl,
      method,
      headers: { ...headers, Authorization: getState().auth.token },
      [dataOrParams]: data,
    })
    .then(({ data, headers, status }) => {
      if (!!!data) {
        dispatch(onSuccess(headers));
      }
      if (status === 200) {
        if (isFunction(onSuccess)) {
          onSuccess(data);
        }

        if (isFunction(onSuccessWithoutDispatch)) {
          onSuccessWithoutDispatch(data);
        }
      }
    })
    .catch((error) => {
      if (!!error.response) {
        if (error.response.status === 401) {
          history.push("/login");
        } else if (error.response.status === 403) {
          notification.error({
            message: "Lỗi",
            description: "Bạn không đủ quyền truy cập",
          });
        } else if (error.response.status === 400) {
          notification.error({
            message: "Lỗi",
            description: "Không được để trống các field",
          });
        }
        if (error.response.data) {
          onFailureWithoutDispatch(error.response.data);
        }
        dispatch(onFailure(error.response));
      }
    })
    .finally(() => {
      // blow the horn - api requested has ended!
      if (label) {
        dispatch(apiEnd(label));
      }
    });
};

export default api;